module.exports = __webpack_public_path__ + "img/002_conforza.130cab0c.gif";